import Color from 'color';

const BLACK_RGB = 'rgba(26, 26, 26, 1)';

// WEPLOY PALETTE
const Theme = {
  border: {
    normal: '1px',
    radius: '8765457436px', // Randomly thought-out number
    thick: '5px',
    thin: '.1875rem',
    veryThin: '.09125rem',
  },
  colors: {
    black: BLACK_RGB,
    danger: 'rgba(250, 50, 53, 1)',
    dangerDark: 'rgba(216, 44, 46, 1)',
    darkerGrey: 'rgba(100, 100, 100, 1)',
    darkGrey: 'rgba(200, 200, 200, 1)',
    disabled: 'rgba(126, 123, 123, 1)',
    error: 'rgba(250, 50, 53, 1)',
    gray: 'rgba(230, 230, 230, 1)',
    primary: 'rgb(179, 237, 229)',
    primaryDark: 'rgba(56, 156, 138, 1)',
    primaryLight: 'rgba(200, 235, 229, 1)',
    shadow: 'rgba(51, 51, 51, 0.1)',
    fadedWeployGrey: Color(BLACK_RGB).lighten(4).string(),
    iconColor: 'rgba(0,0,0,.54)',
    inactiveColor: 'rgba(0,0,0, 0.12)',
    warningYellow: 'rgba(255, 222, 86, 1)',
    weployAqua: 'rgba(85, 219, 202, 1)',
    weployAqua80: 'rgba(85, 219, 202, 0.8)',
    weployBlue: 'rgba(3, 106, 198, 1)',
    weployeePink: 'rgba(241, 77, 180, 1)',
    weployerPlum: 'rgba(59, 63, 182, 1)',
    weployerPlumLight: 'rgba(79, 83, 202, 1)',
    weployLightGrey: 'rgba(221, 229, 237, 1)',
    white: 'rgba(255, 255, 255, 1)',
    // These are colour for Job Visibility
    brand: {
      primary: 'rgba(186, 237, 230)', // HEX: #B3EDE5
      secondary: 'rgb(102, 133, 125)',
    },
    surface: {
      default: 'rgba(255, 255, 255)', // HEX: #FFFFFF
    },
    background: {
      default: 'rgba(255, 255, 255)', // HEX: #FFFFFF
    },
    text: {
      primary: 'rgb(23, 82, 74)',
      secondary: 'rgba(23, 82, 74, 0.75)',
      disabled: 'rgba(0, 0, 0, 0.38)', // #00000061
      hint: 'rgba(0, 0, 0, 0.38)', // #00000061
      primaryOnDark: 'rgba(23, 82, 74)', // HEX: #17524A
      secondaryOnDark: 'rgba(255, 255, 255, 0.7)', // HEX: #FFFFFFB3
      disabledOnDark: 'rgba(255, 255, 255, 0.5)', // HEX: #FFFFFF80
      hintOndark: 'rgba(255, 255, 255, 0.5)', // HEX: #FFFFFF80
    },
    icon: {
      default: 'rgba(0, 0, 0, 0.54)', // #0000008A
    },
    semantic: {
      warning: 'rgba(255, 77, 0)', // HEX: #FF4D00
    },
    border: {
      default: 'rgba(0, 0, 0, 0.12)',
    },
  },
  spacing: {
    unit: 8,
  },
  // We want to deprecate this spacing for MaterialUI components
  space: {
    double: '2.5rem',
    half: '.625rem',
    quarter: '.3125rem',
    single: '1.25rem',
    borderedHalf: '.435rem',
    borderedSingle: '1.0625rem',
  },
  typography: {
    small: '.75rem',
    normal: '1rem',
    large: '1.25rem',
  },
  modalStyle: {
    overlay: {
      backgroundColor: 'rgba(51, 51, 51, 0.86)',
      display: 'flex',
      alignItems: 'center',
      zIndex: 3, // This is so calendar items do not get shown above overlay
    },
    content: {
      backgroundColor: 'rgba(255, 255, 255, 1)',
    },
  },
  grid: {
    spacing: 3,
  },
  icons: {
    small: '1.3rem',
    medium: '1.5rem',
    large: '2rem',
  },
  // old stuff to fix up
  // Colours
  colourAqua: '#49BEA9',
  colourAqua80: 'rgba(73, 190, 169, 0.8)',
  colourCharcoal: '#4A4A4A',
  colourRed: '#FA3235',
  colourDarkGrey: '#7E7B7B',
  colourLighterGrey: '#E9E8E8',
  colourLighterGrey80: 'rgba(233, 232, 232, 0.8)',
  colourOverlay: 'rgba(51, 51, 51, 0.7)',

  // Spacing
  spacingHalf: '.5rem',
  spacingDefault: '1rem',
};

export default Theme;
